module.exports = __webpack_public_path__ + "static/media/screenshot1.b3e1ec7d.jpeg";